import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "13",
  fill: "none",
  viewBox: "0 0 13 13"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.2 9.2a4 4 0 1 0 0-8 4 4 0 0 0 0 8m0 1.2A5.2 5.2 0 1 0 5.2 0a5.2 5.2 0 0 0 0 10.4",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m9.301 10.15.847-.847 2.545 2.545a.4.4 0 0 1 0 .566l-.28.28a.4.4 0 0 1-.567 0z"
    }, null, -1)
  ])))
}
export default { render: render }